import { Link } from "react-router-dom";
import { useTenant } from "../lib/tenant";

export default function AboutPage() {
  const { id: tenantId, tTenant } = useTenant();
  const isChlorine = tenantId === "chlorine.art";

  // Safely get the promise array
  const promiseArray = tTenant("about.promise", { returnObjects: true });
  const displayPromise = Array.isArray(promiseArray) ? promiseArray : [];

  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="font-display text-4xl font-bold text-gray-900 mb-4">
        {tTenant("about.title")}
      </h1>
      <div className={`w-16 h-1 rounded-full mb-10`} style={{ backgroundColor: 'rgb(var(--brand-color))' }} />

      <div className="space-y-6 text-gray-600 leading-relaxed">
        <p
          className="text-lg text-gray-700"
          dangerouslySetInnerHTML={{ __html: tTenant("about.intro") }}
        />

        <h2 className="font-display text-2xl font-bold text-gray-900 mt-10 mb-4">
          {tTenant("about.storyTitle")}
        </h2>
        <p>{tTenant("about.story")}</p>
        <p>{tTenant("about.story2")}</p>

        {/* Print section */}
        <div className={`my-10 rounded-2xl p-8 text-white ${isChlorine ? "bg-black border border-white/10" : "bg-gradient-to-br from-brand-900 to-gray-900"}`}>
          <h2 className="font-display text-2xl font-bold mb-4">
            🖨️ {tTenant("about.printTitle")}
          </h2>
          <p
            className="text-gray-300 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: tTenant("about.print") }}
          />
          <div className="grid grid-cols-2 gap-4 mt-6">
            {[
              { v: tTenant("print.stat1"), sub: tTenant("print.stat1sub") },
              { v: tTenant("print.stat2"), sub: tTenant("print.stat2sub") },
              { v: tTenant("print.stat3"), sub: tTenant("print.stat3sub") },
              { v: tTenant("print.stat4"), sub: tTenant("print.stat4sub") },
            ].map((s) => (
              <div key={s.v} className="rounded-xl bg-white/5 border border-white/10 p-4 text-center">
                <p className="font-display text-xl font-bold">{s.v}</p>
                <p className="text-[10px] uppercase tracking-widest text-gray-400 mt-1">{s.sub}</p>
              </div>
            ))}
          </div>
        </div>

        <h2 className="font-display text-2xl font-bold text-gray-900 mt-10 mb-4">
          {tTenant("about.promiseTitle")}
        </h2>
        <ul className="list-none space-y-3">
          {displayPromise.map((item: string) => (
            <li key={item} className="flex items-start gap-2">
              <span className="shrink-0 mt-1">•</span>
              {item}
            </li>
          ))}
        </ul>

        <div className="mt-12 p-8 rounded-2xl text-center" style={{ backgroundColor: 'rgba(var(--brand-color), 0.05)' }}>
          <p className="font-display text-xl font-semibold mb-4" style={{ color: 'rgb(var(--brand-color))' }}>
            {tTenant("about.cta")}
          </p>
          <Link to="/shop" className="btn-primary">
            {tTenant("about.ctaBtn")}
          </Link>
        </div>
      </div>
    </main>
  );
}
